import React from 'react';

interface AddressBlockIconProps {
  fill?: string;
  width?: number;
  height?: number;
}

const AddressBlockIcon: React.FC<AddressBlockIconProps> = ({
  fill = 'currentColor',
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="address-block-icon"
    >
      {/* House icon */}
      <path
        d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Door */}
      <path
        d="M9 22V12H15V22"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Envelope overlay */}
      <path
        d="M16 6H8C7.44772 6 7 6.44772 7 7V13C7 13.5523 7.44772 14 8 14H16C16.5523 14 17 13.5523 17 13V7C17 6.44772 16.5523 6 16 6Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7 8L12 11L17 8"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export default AddressBlockIcon;
